<template>
    <b-modal
        v-model="modalShow"
        size="xl"
        :title="`${$locale.patient}情報`"
        :ok-only="true"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @hidden="close">
        <div v-if="user">
            <div class="mb-3">
                <div class="card">
                    <div class="card-header">
                        <div class="font-weight-bold">基本情報</div>
                    </div>

                    <div class="card-body">
                        <user-profile :user="user" userType="admin"></user-profile>
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <admin-doctor-medical-records
                      :user="user"
                      :doctor_id="doctorId"
                      :timezone="timezone">
                </admin-doctor-medical-records>
            </div>

            <div
                v-if="consultationId"
                class="mb-3">
                <admin-doctor-interview-answers
                      :consultation-id="consultationId">
                </admin-doctor-interview-answers>
            </div>

            <div
                v-if="$locale.type === 'consul' && !this.isGroupUser"
                class="mb-3">
                <admin-user-coupons
                    :user="user"
                    :paginate="false"
                    is-clear-search-condition
                    as-user-profile>
                </admin-user-coupons>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        props: {
            timezone: {
                type: String,
                default: 'Asia/Tokyo',
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                user: null,
                consultationId: null,
                doctorId: null,
                modalShow: false,
            }
        },

        computed: {
            /**
             * グループに所属しているかどうか
             *
             * @return {boolean}
             */
            isGroupUser: function () {
                return this.helper.isGroupUser(this.user)
            },
        },

        created: function() {
            bus.$on('open-modal-admin-user-profile', this.open)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-admin-user-profile')
        },

        methods: {
            /**
             * モーダルを表示
             *
             * @param userId
             * @param consultationId
             * @param doctorId
             */
            open: function (userId, consultationId = null, doctorId = null) {
                this.fetchUserProfile(userId)
                this.consultationId = consultationId
                this.doctorId = doctorId
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function() {
                this.user = null
                this.consultationId = null
                this.doctorId = null
                this.modalShow = false
            },

            /**
             * 会員プロフィール
             * @param {number} userId
             */
            fetchUserProfile: function (userId) {
                axios.get(`${constants.admin.users.endpoint.base}/${userId}`)
                    .then(({data}) => {
                        this.user = data
                    })
            },
        },
    }
</script>
